import React, { useState } from "react";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import "./navibar.css";
import logo from "../../assets/port_react.name.png";


const Menu = () => (
  <>
    <p>
      <a href="#home">Home</a>
    </p>
    <p>
      <a href="#about">About</a>
    </p>
    <p>
      <a href="#portfolio">Portfolio</a>
    </p>
  </>
);

const Navibar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  return (
    <div className="port__navibar">
      <div className="port__navibar-links">
        <div className="port__navibar-links-logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="port__navibar-links_container">
          <Menu />
        </div>
      </div>

      <div className="port__navibar-sign">
        <a href="#contact">
          <button type="button">Let's talk</button>
        </a>
      </div>

      <div className="port__navibar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
        {toggleMenu && (
          <div className="port__navibar-menu_container scale-up-center">
            <div className="port__navibar-menu_container-links">
              <Menu />
              <div className="port__navibar-menu_sign">
                <a href="#contact">
                <button type="button">Let's talk</button>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navibar;
